// Quiz for tik tok

import { QUESTIONS_TYPE } from '../constants/default/quiz';
import type { QuizCollectionModel } from '@/common/models/quiz.model';

// percentStep = 100 / questions count
const percentStep = 3.57;

export const quiz: QuizCollectionModel = {
  0: {
    id: 0,
    progress: 0,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Choose your main goal' },
    prevLink: '/',
    options: [
      {
        id: 0,
        text: { en: 'Improve Erectile Function' },
        nextLink: 1,
        goals: { main: 'goal_erectile_function', additional: 'add_goal_ejaculation_control' },
      },
      {
        id: 1,
        text: { en: 'Improve Ejaculation Control' },
        nextLink: 101,
        goals: { main: 'goal_ejaculation_control', additional: 'add_goal_erectile_function' },
      },
      {
        id: 2,
        text: { en: 'Maximize Intimate Wellness' },
        description: { en: '(Improve both of the above)' },
        nextLink: 201,
        goals: { main: 'goal_sexual_wellness', additional: '' },
      },
    ],
  },

  // FIRST BRANCH - Improve Erectile Function

  1: {
    id: 1,
    progress: percentStep,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Which one best describes your problem?' },
    prevLink: 0,
    nextLink: 3,
    options: [
      { id: 0, text: { en: 'Difficulty achieving erection' } },
      { id: 1, text: { en: 'Difficulty maintaining erection' } },
      { id: 2, text: { en: 'Both' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  3: {
    id: 3,
    progress: percentStep * 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you experience problems with erection?' },
    nextLink: 4,
    prevLink: 1,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  4: {
    id: 4,
    progress: percentStep * 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How long have you been experiencing problems with erection?' },
    nextLink: 5,
    prevLink: 3,
    options: [
      { id: 0, text: { en: 'Less than 1 year' } },
      { id: 1, text: { en: 'From 1 to 5 years' } },
      { id: 2, text: { en: 'From 5 to 10 years' } },
      { id: 3, text: { en: 'More than 10 years' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  5: {
    id: 5,
    progress: percentStep * 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Can you make love 2 times in a row?' },
    nextLink: 6,
    prevLink: 4,
    options: [
      { id: 0, text: { en: 'Yes, but I must try hard' } },
      { id: 1, text: { en: 'No, I can\'t' } },
      { id: 2, text: { en: 'I don\'t want to answer' } },
    ],
  },
  6: {
    id: 6,
    progress: percentStep * 5,
    type: QUESTIONS_TYPE.s1,
    nextLink: 7,
    prevLink: 5,
    s1: {
      title: 'oldTranslations.quiz.qualityErectionTikTok',
      text: 'oldTranslations.quiz.qualityErectionTextTikTok',
      video: {
        path: '/video/video_ED_s1.mp4',
        poster: '/video/posters/img_ED_s1.webp',
        loop: true,
      },
    },
  },
  7: {
    id: 7,
    progress: percentStep * 6,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you experience morning erections?' },
    nextLink: 8,
    prevLink: 6,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  8: {
    id: 8,
    progress: percentStep * 7,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How hard is your erection during masturbation?' },
    nextLink: 9,
    prevLink: 7,
    leftRate: { en: 'Not hard' },
    rightRate: { en: 'Very hard' },
  },
  9: {
    id: 9,
    progress: percentStep * 8,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How hard is your erection when you make love?' },
    nextLink: 10,
    prevLink: 8,
    leftRate: { en: 'Not hard' },
    rightRate: { en: 'Very hard' },
  },
  10: {
    id: 10,
    progress: percentStep * 9,
    type: QUESTIONS_TYPE.EFFECTIVE_EXERCISES,
    nextLink: 11,
    prevLink: 9,
    s2: {
      title: 'oldTranslations.quiz.kegelExercisesTikTok',
      image: '/images/img_erection_kegels_nokegels.webp',
      source: {
        logo: 'hospital',
        name: '',
        label: 'oldTranslations.quiz.hospital',
      },
    },
  },
  11: {
    id: 11,
    progress: percentStep * 10,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 12,
    prevLink: 10,
    s4: {
      title: 'oldTranslations.quiz.kegelEffectivness',
      image: '/images/img_erection_84.webp',
      review: [7],
      buttons: false,
    },
  },
  12: {
    id: 12,
    progress: percentStep * 11,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How satisfied are you with your intimate life in the last 3 months?' },
    nextLink: 13,
    prevLink: 11,
    leftRate: { en: 'Not satisfied' },
    rightRate: { en: 'Very satisfied' },
  },
  13: {
    id: 13,
    progress: percentStep * 12,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How much do you worry about having problem with erection?' },
    nextLink: 14,
    prevLink: 12,
    leftRate: { en: 'I don\'t  worry' },
    rightRate: { en: 'I\'m very worried' },
  },
  14: {
    id: 14,
    progress: percentStep * 13,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How much do erection problems affect the relationship with your partner?' },
    nextLink: 15,
    prevLink: 13,
    leftRate: { en: 'They don\'t affect' },
    rightRate: { en: 'They affect a lot' },
  },
  15: {
    id: 15,
    progress: percentStep * 14,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Does your self-esteem suffer from problems with erection?' },
    nextLink: 16,
    prevLink: 14,
    options: [
      { id: 0, text: { en: 'Yes, it does' } },
      { id: 1, text: { en: 'No, it doesn\'t' } },
      { id: 2, text: { en: 'I don\'t want to answer' } },
    ],
  },
  16: {
    id: 16,
    progress: percentStep * 15,
    type: QUESTIONS_TYPE.GOALS_REVIEWS,
    titleKey: 'ed_pp1_title',
    goalKey: 'ed_pp1_improve_goal',
    byDateKey: 'ed_pp1_by_date',
    noteKey: 'ed_pp1_illustration_note',
    reviewsTitleKey: 'ed_pp1_customer_reviews_title',
    showMoreButtonKey: 'ed_pp1_show_more_button',
    nextLink: 17,
    prevLink: 15,
  },
  17: {
    id: 17,
    progress: percentStep * 16,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How long do you typically last?' },
    nextLink: 18,
    prevLink: 16,
    options: [
      { id: 0, text: { en: 'Less than 2 minutes' } },
      { id: 1, text: { en: '2-7 minutes' } },
      { id: 2, text: { en: '7-15 minutes' } },
      { id: 3, text: { en: '15 or more minutes' } },
    ],
  },
  18: {
    id: 18,
    progress: percentStep * 17,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you finish earlier than you\'d like?' },
    prevLink: 17,
    nextLink: 19,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  19: {
    id: 19,
    progress: percentStep * 18,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you want to improve ejaculation control?' },
    addGoalChoice: true,
    prevLink: '/quiz/18/question',
    options: [
      { id: 1, text: { en: 'Yes, I\'d like to' }, nextLink: 20 },
      { id: 0, text: { en: 'No, I don\'t want to' }, nextLink: 21 },
    ],
  },
  20: {
    id: 20,
    progress: percentStep * 19,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    prevLink: 19,
    nextLink: 21,
    s4: {
      title: 'oldTranslations.quiz.kegelEffectivness2',
      video: {
        path: '/video/video_8outof10.mp4',
        poster: '/video/posters/img_8outof10.webp',
        loop: false,
      },
      review: [81],
      buttons: true,
    },
  },
  21: {
    id: 21,
    progress: percentStep * 20,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How would you rate your libido in the last 3 months?' },
    prevLink: 19,
    nextLink: 22,
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },
  22: {
    id: 22,
    progress: percentStep * 21,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you take any pills to improve erection?' },
    prevLink: 21,
    nextLink: 23,
    options: [
      { id: 0, text: { en: 'Yes, every time' } },
      { id: 1, text: { en: 'I take them sometimes' } },
      { id: 2, text: { en: 'No, I don\'t' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  23: {
    id: 23,
    progress: percentStep * 22,
    type: QUESTIONS_TYPE.KEGEL_BENEFITS,
    titleKey: 'ed_s5_title',
    sourceKey: 'ed_s5_source',
    sourceNameKey: 'ed_s5_source_name',
    prevLink: 22,
    nextLink: 24,
    s5: {
      base: '/images/img_pills_vs_kegel_Erection.webp',
      add: '/images/img_pills_vs_kegel_Erection_Stamina_v2.webp',
    },
  },
  24: {
    id: 24,
    progress: percentStep * 23,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you drink alcohol?' },
    prevLink: 23,
    nextLink: 25,
    options: [
      { id: 0, text: { en: 'Every day' } },
      { id: 1, text: { en: 'Several times a week' } },
      { id: 2, text: { en: 'Once a week' } },
      { id: 3, text: { en: 'Once a month' } },
      { id: 4, text: { en: 'I don\'t drink at all' } },
    ],
  },
  25: {
    id: 25,
    progress: percentStep * 24,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you smoke?' },
    prevLink: 24,
    nextLink: 26,
    options: [
      { id: 0, text: { en: 'Yes, I do' } },
      { id: 1, text: { en: 'No, I don\'t' } },
      { id: 2, text: { en: 'Sometimes' } },
    ],
  },
  26: {
    id: 26,
    progress: percentStep * 25,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How healthy is your diet?' },
    prevLink: 25,
    nextLink: 27,
    leftRate: { en: 'Unhealthy' },
    rightRate: { en: 'Healthy' },
  },
  27: {
    id: 27,
    progress: percentStep * 26,
    type: QUESTIONS_TYPE.GOALS,
    titleKey: 'ed_pp2_title',
    goalKey: 'ed_pp1_improve_goal',
    addGoalKey: 'ed_pp2_improve_goal',
    byDateKey: 'ed_pp2_by_date',
    noteKey: 'ed_pp2_illustration_note',
    durationKey: 'ed_pp2_exercise_duration',
    equipKey: 'ed_pp2_required_equipment',
    exNoteKey: 'ed_pp2_exercise_note',
    prevLink: 26,
    nextLink: 28,
  },
  28: {
    id: 28,
    progress: percentStep * 27,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'What\'s your level of physical activity?' },
    prevLink: 27,
    nextLink: 29,
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },
  29: {
    id: 29,
    progress: percentStep * 28,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How would you rate your daily stress level?' },
    prevLink: 28,
    nextLink: '/quiz/health-onboarding',
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },

  // SECOND BRANCH - Improve Ejaculation Control

  101: {
    id: 101,
    progress: percentStep,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How long do you typically last?' },
    prevLink: 0,
    nextLink: 102,
    options: [
      { id: 0, text: { en: 'Less than 2 minutes' } },
      { id: 1, text: { en: '2-7 minutes' } },
      { id: 2, text: { en: '7-15 minutes' } },
      { id: 3, text: { en: '15 minutes or more' } },
    ],
  },
  102: {
    id: 102,
    progress: percentStep * 2 + 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you finish earlier than you\'d like?' },
    prevLink: 101,
    nextLink: 103,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  103: {
    id: 103,
    progress: percentStep * 3 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How long do you want to last?' },
    prevLink: 102,
    nextLink: 104,
    options: [
      { id: 0, text: { en: '7-15 minutes' } },
      { id: 1, text: { en: '15-20 minutes' } },
      { id: 2, text: { en: '20-25 minutes' } },
      { id: 3, text: { en: 'More than 25 minutes' } },
    ],
  },
  104: {
    id: 104,
    progress: percentStep * 4 + 3,
    type: QUESTIONS_TYPE.s1,
    nextLink: 105,
    prevLink: 103,
    s1: {
      title: 'oldTranslations.quiz.controlEjaculation',
      text: 'oldTranslations.quiz.controlEjaculationText',
      video: {
        path: '/video/video_PE_s1.mp4',
        poster: '/video/posters/img_PE_s1.webp',
        loop: true,
      },
    },
  },
  105: {
    id: 105,
    progress: percentStep * 5 + 4,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How hard is it for you to control your ejaculation when making love?' },
    nextLink: 106,
    prevLink: 104,
    leftRate: { en: 'Not hard' },
    rightRate: { en: 'Very hard' },
  },
  106: {
    id: 106,
    progress: percentStep * 6 + 4,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How hard is it for you to control your ejaculation during masturbation?' },
    nextLink: 107,
    prevLink: 105,
    leftRate: { en: 'Not hard' },
    rightRate: { en: 'Very hard' },
  },
  107: {
    id: 107,
    progress: percentStep * 7 + 5,
    type: QUESTIONS_TYPE.EFFECTIVE_EXERCISES,
    nextLink: 108,
    prevLink: 106,
    s2: {
      title: 'oldTranslations.quiz.kegelExercises1',
      image: '/images/img_sex_duration_kegels_nokegels_v2.webp',
      source: {
        logo: 'sapienza',
        name: '',
        label: 'oldTranslations.quiz.sapienza',
      },
    },
  },
  108: {
    id: 108,
    progress: percentStep * 8 + 5,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 109,
    prevLink: 107,
    s4: {
      title: 'oldTranslations.quiz.kegelEffectivness2',
      video: {
        path: '/video/video_8outof10.mp4',
        poster: '/video/posters/img_8outof10.webp',
        loop: false,
      },
      review: [81],
      buttons: false,
    },
  },
  109: {
    id: 109,
    progress: percentStep * 9 + 4,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How satisfied are you with your intimate life in the last 3 months?' },
    nextLink: 110,
    prevLink: 108,
    leftRate: { en: 'Not satisfied' },
    rightRate: { en: 'Very satisfied' },
  },
  110: {
    id: 110,
    progress: percentStep * 10 + 3,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How much do you worry about ejaculating earlier than you\'d like?' },
    nextLink: 111,
    prevLink: 109,
    leftRate: { en: 'I don\'t  worry' },
    rightRate: { en: 'I\'m very worried' },
  },
  111: {
    id: 111,
    progress: percentStep * 11 + 2,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How much do problems with ejaculation control affect the relationship with your partner?' },
    nextLink: 112,
    prevLink: 110,
    leftRate: { en: 'They don\'t affect' },
    rightRate: { en: 'They affect a lot' },
  },
  112: {
    id: 112,
    progress: percentStep * 12 + 1,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Does your self-esteem suffer from ejaculating earlier than you\'d like?' },
    prevLink: 111,
    nextLink: 113,
    options: [
      { id: 0, text: { en: 'Yes, it does' } },
      { id: 1, text: { en: 'No, it doesn\'t' } },
      { id: 2, text: { en: 'I don\'t want to answer' } },
    ],
  },
  113: {
    id: 113,
    progress: percentStep * 13,
    type: QUESTIONS_TYPE.GOALS_REVIEWS,
    titleKey: 'pe_pp1_title',
    goalKey: 'pe_pp1_improve_goal',
    byDateKey: 'pe_pp1_by_date',
    noteKey: 'pe_pp1_illustration_note',
    reviewsTitleKey: 'pe_pp1_customer_reviews_title',
    showMoreButtonKey: 'pe_pp1_show_more_button',
    prevLink: 112,
    nextLink: 114,
  },
  114: {
    id: 114,
    progress: percentStep * 14,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How would you describe your Erectile function?' },
    prevLink: 113,
    nextLink: 115,
    options: [
      { id: 0, text: { en: 'Everything\'s great' } },
      { id: 1, text: { en: 'Mostly fine, but sometimes I have problems' } },
      { id: 2, text: { en: 'I often have problems' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  115: {
    id: 115,
    progress: percentStep * 15,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you experience difficulty achieving erection?' },
    prevLink: 114,
    nextLink: 116,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  116: {
    id: 116,
    progress: percentStep * 16,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you experience difficulty <span style="text-decoration: underline;">maintaining</span> erection?' },
    prevLink: 115,
    nextLink: 117,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  117: {
    id: 117,
    progress: percentStep * 17,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Can you make love 2 times in a row?' },
    prevLink: 116,
    nextLink: 118,
    options: [
      { id: 0, text: { en: 'Yes, without any problems' } },
      { id: 1, text: { en: 'Yes, but I must try hard' } },
      { id: 2, text: { en: 'No, I can\'t' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  118: {
    id: 118,
    progress: percentStep * 18,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you want to improve your erectile function?' },
    prevLink: 117,
    addGoalChoice: true,
    options: [
      { id: 1, text: { en: 'Yes, I\'d like to' }, nextLink: 119 },
      { id: 0, text: { en: 'No, I don\'t want to' }, nextLink: 120 },
    ],
  },
  119: {
    id: 119,
    progress: percentStep * 19,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 120,
    prevLink: 118,
    s4: {
      title: 'oldTranslations.quiz.kegelEffectivness',
      image: '/images/img_erection_84.webp',
      review: [7],
      buttons: true,
    },
  },
  120: {
    id: 120,
    progress: percentStep * 20,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How would you rate your libido in the last 3 months?' },
    prevLink: 118,
    nextLink: 121,
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },
  121: {
    id: 121,
    progress: percentStep * 21,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you take any pills for premature ejaculation?' },
    prevLink: 120,
    nextLink: 122,
    options: [
      { id: 0, text: { en: 'Yes, every time' } },
      { id: 1, text: { en: 'I take them sometimes' } },
      { id: 2, text: { en: 'No, I don\'t' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  122: {
    id: 122,
    progress: percentStep * 22,
    type: QUESTIONS_TYPE.KEGEL_BENEFITS,
    titleKey: 'pe_s5_title',
    sourceKey: 'pe_s5_source',
    sourceNameKey: 'pe_s5_source_name',
    nextLink: 123,
    prevLink: 121,
    s5: {
      base: '/images/img_pills_vs_kegel_stamina_v2.webp',
      add: '/images/img_pills_vs_kegel_stamina_erection_v2.webp',
    },
  },
  123: {
    id: 123,
    progress: percentStep * 23,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you drink alcohol?' },
    prevLink: 122,
    nextLink: 124,
    options: [
      { id: 0, text: { en: 'Every day' } },
      { id: 1, text: { en: 'Several times a week' } },
      { id: 2, text: { en: 'Once a week' } },
      { id: 3, text: { en: 'Once a month' } },
      { id: 4, text: { en: 'I don\'t drink at all' } },
    ],
  },
  124: {
    id: 124,
    progress: percentStep * 24,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you smoke?' },
    prevLink: 123,
    nextLink: 125,
    options: [
      { id: 0, text: { en: 'Yes, I do' } },
      { id: 1, text: { en: 'No, I don\'t' } },
      { id: 2, text: { en: 'Sometimes' } },
    ],
  },
  125: {
    id: 125,
    progress: percentStep * 25,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How healthy is your diet?' },
    prevLink: 124,
    nextLink: 126,
    leftRate: { en: 'Unhealthy' },
    rightRate: { en: 'Healthy' },
  },
  126: {
    id: 126,
    progress: percentStep * 26,
    type: QUESTIONS_TYPE.GOALS,
    titleKey: 'pe_pp2_title',
    goalKey: 'pe_pp1_improve_goal',
    addGoalKey: 'pe_pp2_improve_goal',
    byDateKey: 'pe_pp2_by_date',
    noteKey: 'pe_pp2_illustration_note',
    durationKey: 'pe_pp2_exercise_duration',
    equipKey: 'pe_pp2_required_equipment',
    exNoteKey: 'pe_pp2_exercise_note',
    prevLink: 125,
    nextLink: 127,
  },
  127: {
    id: 127,
    progress: percentStep * 27,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'What\'s your level of physical activity?' },
    prevLink: 126,
    nextLink: 128,
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },
  128: {
    id: 128,
    progress: percentStep * 28,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How would you rate your daily stress level?' },
    prevLink: 127,
    nextLink: '/quiz/health-onboarding',
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },

  // THIRD BRANCH - Maximize Sexual Wellness (Improve both of the above)

  201: {
    id: 201,
    progress: percentStep,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How satisfied are you with your intimate wellness (erection quality & ejaculation control)?' },
    nextLink: 202,
    prevLink: 0,
    leftRate: { en: 'Not satisfied' },
    rightRate: { en: 'Very satisfied' },
  },
  202: {
    id: 202,
    progress: percentStep * 2 + 2,
    type: QUESTIONS_TYPE.s1,
    nextLink: 203,
    prevLink: 201,
    s1: {
      title: 'oldTranslations.quiz.controlEjaculation',
      text: 'oldTranslations.quiz.controlEjaculationText',
      video: {
        path: '/video/video_PE_s1.mp4',
        poster: '/video/posters/img_PE_s1.webp',
        loop: true,
      },
    },
  },
  203: {
    id: 203,
    progress: percentStep * 3 + 3,
    type: QUESTIONS_TYPE.s1,
    nextLink: 204,
    prevLink: 202,
    s1: {
      title: 'oldTranslations.quiz.qualityErection1TikTok',
      text: 'oldTranslations.quiz.qualityErectionTextTikTok',
      video: {
        path: '/video/video_ED_s1.mp4',
        poster: '/video/posters/img_ED_s1.webp',
        loop: true,
      },
    },
  },
  204: {
    id: 204,
    progress: percentStep * 4 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How long do you typically last?' },
    prevLink: 203,
    nextLink: 205,
    options: [
      { id: 0, text: { en: 'Less than 2 minutes' } },
      { id: 1, text: { en: '2-7 minutes' } },
      { id: 2, text: { en: '7-15 minutes' } },
      { id: 3, text: { en: '15 minutes or more' } },
    ],
  },
  205: {
    id: 205,
    progress: percentStep * 5 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you finish earlier than you\'d like?' },
    prevLink: 204,
    nextLink: 206,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  206: {
    id: 206,
    progress: percentStep * 6 + 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How long do you want to last?' },
    prevLink: 205,
    nextLink: 207,
    options: [
      { id: 0, text: { en: '7-15 minutes' } },
      { id: 1, text: { en: '15-20 minutes' } },
      { id: 2, text: { en: '20-25 minutes' } },
      { id: 3, text: { en: 'More than 25 minutes' } },
    ],
  },
  207: {
    id: 207,
    progress: percentStep * 7 + 4,
    type: QUESTIONS_TYPE.EFFECTIVE_EXERCISES,
    nextLink: 208,
    prevLink: 206,
    s2: {
      title: 'oldTranslations.quiz.kegelExercises1',
      image: '/images/img_sex_duration_7x_v2.webp',
      source: {
        logo: 'sapienza',
        name: '',
        label: 'oldTranslations.quiz.sapienza',
      },
    },
  },
  208: {
    id: 208,
    progress: percentStep * 8 + 5,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 209,
    prevLink: 207,
    s4: {
      title: 'oldTranslations.quiz.kegelEffectivness2',
      video: {
        path: '/video/video_8outof10.mp4',
        poster: '/video/posters/img_8outof10.webp',
        loop: false,
      },
      review: [81],
      buttons: false,
    },
  },
  209: {
    id: 209,
    progress: percentStep * 9 + 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How would you describe your Erectile function?' },
    prevLink: 208,
    nextLink: 210,
    options: [
      { id: 0, text: { en: 'Everything\'s great' } },
      { id: 1, text: { en: 'Mostly fine, but sometimes I have problems' } },
      { id: 2, text: { en: 'I often have problems' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  210: {
    id: 210,
    progress: percentStep * 10 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you experience difficulty achieving erection?' },
    prevLink: 209,
    nextLink: 211,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  211: {
    id: 211,
    progress: percentStep * 11 + 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you experience difficulty <span style="text-decoration: underline;">maintaining</span> erection?' },
    prevLink: 210,
    nextLink: 212,
    options: [
      { id: 0, text: { en: 'Never' } },
      { id: 1, text: { en: 'Rarely' } },
      { id: 2, text: { en: 'Often' } },
      { id: 3, text: { en: 'All the time' } },
      { id: 4, text: { en: 'I don\'t want to answer' } },
    ],
  },
  212: {
    id: 212,
    progress: percentStep * 12,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Can you make love 2 times in a row?' },
    prevLink: 211,
    nextLink: 213,
    options: [
      { id: 0, text: { en: 'Yes, without any problems' } },
      { id: 1, text: { en: 'Yes, but I must try hard' } },
      { id: 2, text: { en: 'No, I can\'t' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  213: {
    id: 213,
    progress: percentStep * 13 - 1,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 214,
    prevLink: 212,
    s4: {
      title: 'oldTranslations.quiz.kegelEffectivness3',
      image: '/images/img_erection_84.webp',
      review: [7],
      buttons: true,
    },
  },
  214: {
    id: 214,
    progress: percentStep * 14 - 1,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How satisfied are you with your intimate life in the last 3 months?' },
    nextLink: 215,
    prevLink: 213,
    leftRate: { en: 'Not satisfied' },
    rightRate: { en: 'Very satisfied' },
  },
  215: {
    id: 215,
    progress: percentStep * 15 - 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you have a regular partner?' },
    prevLink: 214,
    nextLink: 217,
    options: [
      { id: 0, text: { en: 'Yes, I do' } },
      { id: 1, text: { en: 'I have a partner, but not regular' } },
      { id: 2, text: { en: 'No, I don\'t' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  217: {
    id: 217,
    progress: percentStep * 17 - 3,
    type: QUESTIONS_TYPE.GOALS_REVIEWS,
    titleKey: 'ok_pp1_title',
    goalKey: 'ok_pp1_improve_goal',
    byDateKey: 'ok_pp1_by_date',
    noteKey: 'ok_pp1_illustration_note',
    reviewsTitleKey: 'ok_pp1_customer_reviews_title',
    showMoreButtonKey: 'ok_pp1_show_more_button',
    prevLink: 215,
    nextLink: 218,
  },
  218: {
    id: 218,
    progress: percentStep * 18 - 3,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How would you rate your libido in the last 3 months?' },
    prevLink: 217,
    nextLink: 219,
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },
  219: {
    id: 219,
    progress: percentStep * 19 - 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you take any pills to improve performance?' },
    prevLink: 218,
    nextLink: 220,
    options: [
      { id: 0, text: { en: 'Yes, every time' } },
      { id: 1, text: { en: 'I take them sometimes' } },
      { id: 2, text: { en: 'No, I don\'t' } },
      { id: 3, text: { en: 'I don\'t want to answer' } },
    ],
  },
  220: {
    id: 220,
    progress: percentStep * 20 - 3,
    type: QUESTIONS_TYPE.KEGEL_BENEFITS,
    titleKey: 'ok_s6_title',
    sourceKey: 'ok_s6_source',
    sourceNameKey: 'ok_s6_source_name',
    nextLink: 221,
    prevLink: 219,
    s5: {
      base: '/images/img_pills_vs_kegel_Erection_Stamina_v2.webp',
    },
  },
  221: {
    id: 221,
    progress: percentStep * 21,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'How often do you drink alcohol?' },
    prevLink: 220,
    nextLink: 222,
    options: [
      { id: 0, text: { en: 'Every day' } },
      { id: 1, text: { en: 'Several times a week' } },
      { id: 2, text: { en: 'Once a week' } },
      { id: 3, text: { en: 'Once a month' } },
      { id: 4, text: { en: 'I don\'t drink at all' } },
    ],
  },
  222: {
    id: 222,
    progress: percentStep * 22,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { en: 'Do you smoke?' },
    prevLink: 221,
    nextLink: 223,
    options: [
      { id: 0, text: { en: 'Yes, I do' } },
      { id: 1, text: { en: 'No, I don\'t' } },
      { id: 2, text: { en: 'Sometimes' } },
    ],
  },
  223: {
    id: 223,
    progress: percentStep * 23,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How healthy is your diet?' },
    prevLink: 222,
    nextLink: 224,
    leftRate: { en: 'Unhealthy' },
    rightRate: { en: 'Healthy' },
  },
  224: {
    id: 224,
    progress: percentStep * 24,
    type: QUESTIONS_TYPE.GOALS,
    titleKey: 'ok_pp2_title',
    goalKey: 'ok_pp1_improve_goal',
    addGoalKey: 'ok_pp2_improve_goal',
    byDateKey: 'ok_pp2_by_date',
    noteKey: 'ok_pp2_illustration_note',
    durationKey: 'ok_pp2_exercise_duration',
    equipKey: 'ok_pp2_required_equipment',
    exNoteKey: 'ok_pp2_exercise_note',
    prevLink: 223,
    nextLink: 225,
  },
  225: {
    id: 225,
    progress: percentStep * 25,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'What\'s your level of physical activity?' },
    prevLink: 224,
    nextLink: 226,
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },
  226: {
    id: 226,
    progress: 100,
    type: QUESTIONS_TYPE.RATE,
    question: { en: 'How would you rate your daily stress level?' },
    prevLink: 225,
    nextLink: '/quiz/health-onboarding',
    leftRate: { en: 'Low' },
    rightRate: { en: 'High' },
  },
};
